import ChargeHelper from 'features/Charge/chargeHelper';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import KTRadio, { KTRadioType } from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import CustomDateRangePicker from 'general/components/Others/CustomDateRangePicker';
import CustomDropdownMultiChoiceView from 'general/components/quybka/Others/CustomDropdownMultiChoiceView';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

MaintainerTicketListFilterView.propTypes = {
    selectedChargeStation: PropTypes.object,
    setSelectedChargeStation: PropTypes.func,
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
    adminRole: PropTypes.bool,
    isMine: PropTypes.bool,
    stationId: PropTypes.string,
    currentLat: PropTypes.string,
    currentLon: PropTypes.string,
};

function MaintainerTicketListFilterView({
    selectedChargeStation,
    setSelectedChargeStation,
    setFilterDropdown,
    filterDropdown,
    adminRole = false,
    isMine = false,
    stationId,
    currentLat,
    currentLon,
}) {
    // MARK: ---- PROPERTIES ----
    const { user } = useSelector((state) => state.auth);

    const dropdownStationEl = useMemo(() => {
        return (
            <CustomDropdownMultiChoiceView
                id="stationId"
                name="stationId"
                toggleElement={({ showError }) => (
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'border-invalid' : ''}`}
                        type="button"
                    >
                        {selectedChargeStation?.length > 0 ? selectedChargeStation.map(item => item.name).join(', ') : 'Chọn trạm sạc'}
                    </button>
                )}
                selectedValue={selectedChargeStation}
                dropdownMenuItems={[{ name: 'Trạm sạc', role: 'STATION' }]}
                getSubItems={async (item) => {
                    try {
                        return await ChargeHelper.API.requestGetChargeStationList(
                            Utils.filterParams({
                                page: item?.page || 0,
                                limit: 10,
                                q: item?.q || '',
                            })
                        ).then((data) => {
                            return {
                                values: data.chargeStations?.map((station) => ({
                                    id: station?.stationId,
                                    name: station?.name,
                                    item: station,
                                })),
                                total: data.total,
                            };
                        });
                    } catch (error) {
                        console.error('Error fetching station list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeStation(value);
                }}
                onSave={(value) => {
                    setFilterDropdown({
                        ...filterDropdown,
                        stationId: value?.length > 0 ? value.map(item => item.id).join(', ') : ''
                    });
                }}
                enableCheckValid
                isDropdownForm={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Trạm sạc',
                    role: 'STATION',
                }}
                idCheckType='id'
            />
        );
    }, [selectedChargeStation]);

    // MARK: ---- METHODS ----

    return (
        <div>
            <div className={`${'col-12 p-0'}`}>
                <KTFormSearch
                    name="search-bar"
                    placeholder={
                        adminRole
                            ? 'Theo mã công việc, trụ sạc, kỹ thuật viên'
                            : 'Theo mã công việc, trụ sạc'
                    }
                    value={MaintainerHelper.Filter.ticketList.q}
                    onSubmit={(text) => {
                        setFilterDropdown({ ...filterDropdown, q: text });
                    }}
                />
            </div>
            <div className='row d-flex flex-row flex-wrap'>
                {/* loc theo tram sac */}
                {!stationId && (
                    <div className={(adminRole || isMine) ? 'col-md-6 py-2 pr-2' : 'col-12 py-2'}>
                        <div style={UIHelper.buildFontStyle('700', '13px', AppColors.gray[800])}>
                            Trạm sạc
                        </div>
                        {dropdownStationEl}
                    </div>
                )}
                {/* loc theo vi tri cong viec */}
                {!adminRole && !isMine && (
                    <div className={!stationId ? 'col-md-6 pr-2' : 'col-12'}>
                        <KTDropdownFilter
                            label="Vị trí"
                            filterKey="locationType"
                            options={[
                                { name: 'Vị trí đăng ký làm việc', value: 'WORK-LOCATION' },
                                { name: 'Vị trí hiện tại', value: 'LIVE-LOCATION' },
                            ]}
                            selectedValue={filterDropdown.locationType}
                            handleChange={(value) => {
                                const updateLocation = (locationType, latitude, longitude) => {
                                    setFilterDropdown(prev => ({ ...prev, locationType, latitude, longitude }));
                                };

                                if (value === 'WORK-LOCATION') {
                                    const latitude = user?.agency?.workAddress?.latitude;
                                    const longitude = user?.agency?.workAddress?.longitude;

                                    if (latitude !== undefined && longitude !== undefined) {
                                        updateLocation(value, latitude, longitude);
                                    }
                                }

                                else if (value === 'LIVE-LOCATION') {
                                    if (currentLat, currentLon) {
                                        updateLocation(value, currentLat, currentLon);
                                    } else {
                                        ToastHelper.showError('Bạn đã từ chối chia sẻ vị trí. Vui lòng vào cài đặt trình duyệt để bật lại quyền truy cập vị trí.');
                                    }
                                }
                            }}
                        />
                    </div>
                )}
                {/* loc theo hinh thuc tinh phi */}
                {(adminRole || isMine) && (
                    <div className={!stationId ? 'col-md-6 pl-2' : 'col-12'}>
                        <KTDropdownFilter
                            label="Hình thức tính phí"
                            filterKey="hasFee"
                            options={[
                                { name: 'Tất cả', value: '' },
                                { name: 'Có phí', value: '1' },
                                { name: 'Miễn phí', value: '0' },
                            ]}
                            selectedValue={filterDropdown.hasFee}
                            additionalClassName="w-100"
                            handleChange={(value) => {
                                setFilterDropdown({ ...filterDropdown, hasFee: value });
                            }}
                        />
                    </div>
                )}
                {/* loc theo trang thai cong viec */}
                {(adminRole || isMine) && (
                    <div className='col-md-6 pr-2'>
                        <KTDropdownFilter
                            label="Trạng thái công việc"
                            filterKey="status"
                            options={adminRole
                                ? [
                                    { name: 'Tất cả', value: '' },
                                    ...MaintainerHelper.Data.ticketStatusOptions
                                ]
                                : [
                                    { name: 'Tất cả', value: '' },
                                    ...MaintainerHelper.Data.maintainerTicketStatusOptions
                                ]
                            }
                            selectedValue={filterDropdown.status}
                            handleChange={(value) => {
                                setFilterDropdown({
                                    ...filterDropdown,
                                    status: value,
                                })
                            }}
                        />
                    </div>
                )}
                {/* loc theo do uu tien */}
                <div className='col-md-6 pl-2'>
                    <KTDropdownFilter
                        label="Độ ưu tiên"
                        filterKey="priority"
                        options={[
                            { name: 'Tất cả', value: '' },
                            ...MaintainerHelper.Data.ticketPriorityOptions
                        ]}
                        selectedValue={filterDropdown.priority}
                        handleChange={(value) => {
                            setFilterDropdown({ ...filterDropdown, priority: value });
                        }}
                    />
                </div>
                {/* loc theo loai cong viec */}
                <div className='col-md-6 pr-2'>
                    <KTDropdownFilter
                        label="Loại công việc"
                        filterKey="type"
                        options={[
                            { name: 'Tất cả', value: '' },
                            ...MaintainerHelper.Data.ticketTypeOptions
                        ]}
                        selectedValue={filterDropdown.type}
                        handleChange={(value) => {
                            setFilterDropdown({ ...filterDropdown, type: value });

                        }}
                    />
                </div>
                {/* loc theo trang thai thanh toan */}
                {(adminRole || isMine) && (
                    <div className='col-md-6 pl-2'>
                        <KTDropdownFilter
                            label="Trạng thái thanh toán"
                            filterKey="paymentStatus"
                            options={[
                                { name: 'Tất cả', value: '' },
                                ...MaintainerHelper.Data.paymentStatusOptions
                            ]}
                            selectedValue={filterDropdown.paymentStatus}
                            handleChange={(value) => {
                                setFilterDropdown({ ...filterDropdown, paymentStatus: value });

                            }}
                        />
                    </div>
                )}

                {/* loc theo khoang thoi gian */}
                {!adminRole && !isMine && (
                    <div className="col-6 py-2 pl-2">
                        <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                            Khoảng thời gian
                        </label>
                        <CustomDateRangePicker
                            toggleElementBorderRadius={5}
                            alignRight={true}
                            initialValue={filterDropdown.createdSelectedValue}
                            filterComponent={{ from: filterDropdown?.createdFrom, to: filterDropdown?.createdTo }}
                            onPressSave={(selectedValue, startDate, endDate) => {
                                const updateFilterDropdown = {
                                    ...filterDropdown,
                                    createdFrom: startDate,
                                    createdTo: endDate,
                                    createdSelectedValue: selectedValue,
                                    from: startDate,
                                    to: endDate,
                                    selectedValue: selectedValue,
                                };
                                setFilterDropdown(updateFilterDropdown);
                            }}
                        />
                    </div>
                )}

                {(adminRole || isMine) && (
                    <>
                        <div className="col-12 mb-4 p-0 px-4 mt-2"
                            style={{
                                borderTop: `1px dashed ${AppColors.gray[300]}`
                            }}
                        />
                        <div className="d-flex align-items-end mb-2">
                            <div className="radio-inline w-100">
                                <div className="d-flex gap-5">
                                    <KTRadio
                                        name="createdDate"
                                        label="Thời gian gửi lỗi"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            const updateFilterDropdown = {
                                                ...filterDropdown,
                                                timeFilterType: 'CREATED_DATE',
                                            };
                                            setFilterDropdown(updateFilterDropdown);
                                        }}
                                        checked={filterDropdown.timeFilterType === 'CREATED_DATE'}
                                    />
                                    <KTRadio
                                        name="completedDate"
                                        label="Thời gian hoàn thành"
                                        type={KTRadioType.outline}
                                        additionalClassName="radio-success"
                                        onChange={() => {
                                            const updateFilterDropdown = {
                                                ...filterDropdown,
                                                timeFilterType: 'COMPLETED_DATE',
                                            };
                                            setFilterDropdown(updateFilterDropdown);
                                        }}
                                        checked={filterDropdown.timeFilterType === 'COMPLETED_DATE'}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* khoang thoi gian */}
                        <div className="col-12 p-0 px-4">
                            {UIHelper.buildFormLabel(filterDropdown.timeFilterType === 'CREATED_DATE' ? 'Thời gian gửi lỗi' : 'Thời gian hoàn thành')}
                            <CustomDateRangePicker
                                inlineMode={true}
                                toggleElementBorderRadius={5}
                                initialValue={filterDropdown.createdSelectedValue}
                                filterComponent={{ from: filterDropdown?.createdFrom, to: filterDropdown?.createdTo }}
                                onPressSave={(selectedValue, startDate, endDate) => {
                                    const updateFilterDropdown = {
                                        ...filterDropdown,
                                        createdFrom: startDate,
                                        createdTo: endDate,
                                        createdSelectedValue: selectedValue,
                                        from: startDate,
                                        to: endDate,
                                        selectedValue: selectedValue,
                                    };
                                    setFilterDropdown(updateFilterDropdown);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default MaintainerTicketListFilterView;
